import React from "react";
import { Dialog, DialogContent, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Ticket from "../Ticket";
import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";

// Popup de "ver conversa" sem sair da tela atual - pedido do usuario
// 2026-09-29 na tela de Confirmação de Pendências ("poderia abrir um
// popup" em vez de navegar pra /tickets/:uuid e perder o lugar na
// lista). Reaproveita o componente Ticket inteiro (mesmo usado na rota
// normal /tickets/:ticketId) - ver o prop opcional "ticketId" adicionado
// la' pra isso funcionar fora da rota.
//
// QueueSelectedProvider e' obrigatorio aqui - MessagesList (renderizado
// dentro de Ticket) le' esse contexto direto (useContext sem checar
// undefined), e ele so' e' montado dentro de TicketsAdvanced/TicketsCustom
// na rota normal. Sem ele, a tela inteira quebrava com tela branca
// (bug real encontrado testando: "Cannot read properties of undefined
// (reading 'selectedQueuesMessage')").
const TicketViewModal = ({ open, onClose, ticketId }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    PaperProps={{ style: { height: "85vh", display: "flex", flexDirection: "column" } }}
  >
    <IconButton
      size="small"
      onClick={onClose}
      style={{ position: "absolute", top: 6, right: 6, zIndex: 1, backgroundColor: "rgba(255,255,255,0.85)" }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
    <DialogContent style={{ padding: 0, flex: 1, minHeight: 0, display: "flex" }}>
      {open && ticketId && (
        <QueueSelectedProvider>
          <Ticket ticketId={ticketId} />
        </QueueSelectedProvider>
      )}
    </DialogContent>
  </Dialog>
);

export default TicketViewModal;
